<template>
  <div>
    <v-form>
      <v-select
        class="language-selector"
        v-model="selected"
        :items="langList"
        outlined
        width=50
        @change="loadLanguageAsync">
        <template slot="selection" slot-scope='{ item }'>{{$t(`msg.${item.value}`)}}</template>
        <template slot="item" slot-scope='{ item }'>{{$t(`msg.${item.value}`)}}</template>
      </v-select>
    </v-form>
  </div>
</template>
<script>
import { EventBus } from '../_helpers'
export default {
  data () {
    return {
      langList: [
        { value: 'en', text: 'en' },
        // { value: 'ms', text: 'ms' }
      ],
      langs: ['en'],
      // langs: ['en', 'ms'],
      loadedLanguages: ['en'],
      selected: null
    }
  },
  mounted () {
    if (this.$cookies.isKey('nedas_lang') && this.langList.find(lang => lang.value === this.$cookies.get('nedas_lang'))) {
      this.loadLanguageAsync(this.$cookies.get('nedas_lang'))
      this.selected = this.langList.find(lang => lang.value === this.$cookies.get('nedas_lang'))
    } else {
      this.$cookies.set('nedas_lang', 'en', null, null, null, false, 'Strict')
      this.selected = this.langList.find(lang => lang.value === 'en')
    }
  },
  methods: {
    setI18nLanguage: function (lang) {
      this.$i18n.locale = lang
      this.$cookies.set('nedas_lang', lang)
      EventBus.$emit('handleLanguageChange')
    },
    loadLanguageAsync: function (newLang) {
      let lang = newLang

      if (newLang.value) { lang = newLang.value }

      if (this.$i18n.locale !== lang) {
        if (!this.loadedLanguages.includes(lang)) {
          return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {
            this.$i18n.setLocaleMessage(lang, msgs[lang])
            this.loadedLanguages.push(lang)
            return this.setI18nLanguage(lang)
          })
        }
        return Promise.resolve(this.setI18nLanguage(lang))
      }
      EventBus.$emit('handleLanguageChange', lang)
      return Promise.resolve(lang)
    }
  }
}
</script>
<style>
  .language-selector .v-select__selections input { display: none}

  div .v-select-list .v-list-item:hover {
    background-color: #e1ebf8;
  }
</style>
